<template>
  <div>
    <div class="relative text-center">
      <slot name="header" />
    </div>
    <div class="mx-8 md:mx-24 mt-4">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "login-box",
};
</script>
